import type { RouteRecordRaw } from 'vue-router'

export const privacy: RouteRecordRaw = {
	component: () => import('components/modules/Privacy.vue'),
	meta: {
		title: 'Nutzungsbedingungen | Datenschutz',
	},
	name: 'privacy',
	path: '/privacy',
}
